
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  props: ['user'],
  setup (props) {
    const router = useRouter()
    const pointTitle = 'こんにちは、' + props.user.name + 'さん'
    const activeNames = [1]
    if (!props.user.login) {
      console.log('Can\'t access MyPage for not login.')
      router.back()
    }

    return {
      pointTitle,
      activeNames
    }
  }
})
